import SaveIcon from '@mui/icons-material/Save';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Box, Button, Grid, IconButton, InputAdornment, LinearProgress, Link, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useHistory, useParams } from 'react-router';

import { DataAPIContext, UPDATE } from '../api';
import RecordDetails, { RecordDetailsContext } from '../components/RecordDetails';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        border: `1px solid ${grey[200]}`,
        borderRadius: '5px',
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(8),
    },
    gridRoot: {
        margin: theme.spacing(1),
    },
    buttonPanel: {
        backgroundColor: grey[100],
    },
}));

const UserPasswordReset = (props) => {
    const dataAPI = React.useContext(DataAPIContext);
    const history = useHistory();
    const classes = useStyles();
    const resetPasswordRef = React.useRef(null);
    const [syncActive, setSyncActive] = React.useState(false);
    const [errors, setErrors] = React.useState([]);
    const [pw, setPw] = React.useState({
        oldPassword: '',
        newPassword1: '',
        newPassword2: '',
        oldPasswordVisible: false,
        newPassword1Visible: false,
        newPassword2Visible: false,
    });

    const updatePassword = (field, value, ev) => {
        setPw({ ...pw, [field]: value });
        setErrors([]);
    };

    const handleResetPassword = (ev) => {
        console.log('reset', pw);
        setSyncActive(true);
        const params = {
            id: props.id,
            urlSuffix: 'update_password/',
            data: pw,
        };
        dataAPI(UPDATE, props.resource, params)
            .then((res) => {
                console.log('pw res', res, res);
                if (res.statusCode === 406) {
                    setErrors(res.data.errors);
                } else {
                    history.push(`${props.resource}/${props.id}`);
                }
            })
            .finally(() => {
                setSyncActive(false);
            });
    };

    const password1errorProps = errors && errors.length > 0 ? { error: true, helperText: errors.join(' ') } : {};
    const passwordsEqual = pw.newPassword1 === pw.newPassword2;
    const password2errorProps = pw.newPassword1.length > 0 && pw.newPassword2.length > 0 && pw.newPassword1 !== pw.newPassword2 ? { error: true, helperText: 'Passwords do not match' } : {};

    console.log('UserPasswordReset', errors);

    return (
        <div className={classes.root}>
            <Grid container direction="row" spacing={2} className={classes.gridRoot}>
                <Grid item xs={12}>
                    <LinearProgress color="primary" style={{ visibility: syncActive ? 'visible' : 'hidden' }} />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">Reset password</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2">
                        for <Link href={`/user/${props.data.id}`}>{props.data.display_name}</Link>
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        {...password1errorProps}
                        variant="filled"
                        size="small"
                        name="newPassword1"
                        label="New password"
                        type={pw.newPassword1Visible ? 'text' : 'password'}
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton tabIndex="-1" onClick={(ev) => updatePassword('newPassword1Visible', !pw.newPassword1Visible, ev)}>
                                        {pw.newPassword1Visible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        InputLabelProps={{ shrink: true }}
                        value={pw.newPassword1}
                        onChange={(ev) => updatePassword('newPassword1', ev.target.value)}
                    />
                </Grid>
                <Grid item xs={false} sm={6}></Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        helperText=" "
                        {...password2errorProps}
                        variant="filled"
                        size="small"
                        name="newPassword2"
                        label="Repeat new password"
                        type={pw.newPassword2Visible ? 'text' : 'password'}
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton tabIndex="-1" onClick={(ev) => updatePassword('newPassword2Visible', !pw.newPassword2Visible, ev)}>
                                        {pw.newPassword2Visible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        InputLabelProps={{ shrink: true }}
                        value={pw.newPassword2}
                        onChange={(ev) => updatePassword('newPassword2', ev.target.value)}
                    />
                </Grid>
                <Grid item xs={false} sm={6}></Grid>
            </Grid>
            <Box px={2} p={1} className={classes.buttonPanel}>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                        <Button disabled={!passwordsEqual} ref={resetPasswordRef} color="primary" variant="contained" size="small" onClick={handleResetPassword}>
                            <SaveIcon />
                            &nbsp;Reset password
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
};

const UserPasswordResetWrapper = (props) => {
    const resource = 'user';
    const routeParams = useParams();
    const id = routeParams.id;
    return (
        <RecordDetails resource={resource} id={id}>
            <RecordDetailsContext.Consumer>{(data) => <UserPasswordReset resource={resource} id={id} data={data} />}</RecordDetailsContext.Consumer>
        </RecordDetails>
    );
};

export default UserPasswordResetWrapper;
